/**
 * PC端获取多媒体设备权限方法，包括获取摄像头、麦克风等
 */

/**
  * 获取多媒体权限
  * @param constraints
  */
function getMediaDevices(constraints: MediaStreamConstraints) {
  return navigator.mediaDevices.getUserMedia(constraints);
}

/**
 * 判断是否有摄像头和麦克风权限
 */
function isMediaAllowed() {
  let isCameraAllowed = false;
  let isMicrophoneAllowed = false;
  return navigator.mediaDevices.enumerateDevices().then((devices) => {
    devices.forEach((device) => {
      if (device.kind === 'videoinput' && device.label) {
        isCameraAllowed = true;
      }
      if (device.kind === 'audioinput' && device.label) {
        isMicrophoneAllowed = true;
      }
    });
    return {
      video: isCameraAllowed,
      audio: isMicrophoneAllowed,
    };
  });
}

const mediaUtil = {
  getMediaDevices,
  isMediaAllowed,
};

export default mediaUtil;
